<div class="sub">
    <a (click)="goBack()" class="back-btn"><i class="fas fa-chevron-left"></i> Go Back</a>
    <p class="heading">{{ currentRoute }}</p>
    <p class="sub-text">{{ subText }}</p>
</div>

